/** This file was auto-generated via yarn build:icons */

@import 'components.css';
:host {
  @apply inline-flex;
  line-height: inherit;

  &([size='2xs']) { @apply text-2xs; }
  &([size='xs']) { @apply text-xs; }
  &([size='sm']) { @apply text-sm; }
  &([size='md']) { @apply text-md; }
  &([size='base']) { @apply text-base; }
  &([size='lg']) { @apply text-lg; }
  &([size='xl']) { @apply text-xl; }
  &([size='2xl']) { @apply text-2xl; }
  &([size='3xl']) { @apply text-3xl; }
  &([size='4xl']) { @apply text-4xl; }
  &([size='5xl']) { @apply text-5xl; }
  &([size='6xl']) { @apply text-6xl; }
  &([size='7xl']) { @apply text-7xl; }

  &([stroke-width='2xbold']) { @apply stroke-2xbold; }
  &([stroke-width='3xbold']) { @apply stroke-3xbold; }
  &([stroke-width='bold']) { @apply stroke-bold; }
  &([stroke-width='extrabold']) { @apply stroke-extrabold; }
  &([stroke-width='medium']) { @apply stroke-medium; }
  &([stroke-width='regular']) { @apply stroke-regular; }
  &([stroke-width='semibold']) { @apply stroke-semibold; }
}
